import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { Utils } from 'src/app/shared/services/utilities';
import { EventIconsComponent } from '../event-icons/event-icons.component';
import { MomentPipe } from 'src/app/shared/pipes/moment.pipe';

@Component({
  selector: 'app-calendar-day-view',
  templateUrl: './day-view-event.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, EventIconsComponent, MomentPipe],
})
export class DayViewEventComponent {
  readonly utils = inject(Utils);
  @Input('event') event;
}
